import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FiCheck, FiCheckSquare, FiClock, FiMoreVertical, FiUsers } from 'react-icons/fi';
import { HOME_EASE, HomeFloat } from './HomeMotion';
import tasksPhoto from '../../../images/home/tasks-photo.png';

const STATS = [
  { value: '128', label: 'Total Tasks' },
  { value: '72', label: 'Open' },
  { value: '38', label: 'In Progress', tone: 'progress' },
  { value: '18', label: 'Completed', tone: 'done' },
];

const RECENT_TASKS = [
  { title: 'Follow up with Acme Corp', date: 'May 12', tag: 'High', tone: 'high' },
  { title: 'Prepare Q2 report', date: 'May 14', tag: 'In Progress', tone: 'progress' },
  { title: 'Update client contract', date: 'May 16', tag: 'Medium', tone: 'medium' },
  { title: 'Review onboarding docs', date: 'May 18', tag: 'Low', tone: 'low' },
];

const HomeTaskVisual = () => {
  const reduce = useReducedMotion();

  return (
    <div className="home-task-stage">
      <div className="home-task-photo-wrap">
        <motion.img
          src={tasksPhoto}
          alt="Professional organizing work in flowdo"
          className="home-task-photo"
          draggable="false"
          initial={reduce ? false : { opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.28 }}
          transition={{ duration: 0.7, ease: HOME_EASE }}
        />
      </div>

      <HomeFloat
        className="home-float--task-progress"
        cardClassName="home-float-card--pill home-float-card--pill-progress"
        enterDelay={0.18}
        inView
        drift={{ x: -5, y: -10, duration: 6.2, durationX: 7.4 }}
      >
        <FiClock />
        In Progress
      </HomeFloat>

      <HomeFloat
        className="home-float--task-done"
        cardClassName="home-float-card--pill home-float-card--pill-done"
        enterDelay={0.34}
        inView
        drift={{ x: 4, y: -9, duration: 5.6, durationX: 6.9 }}
      >
        <span className="home-task-pill-check">
          <FiCheck />
        </span>
        Done
      </HomeFloat>

      <HomeFloat
        className="home-float--task-panel"
        cardClassName="home-float-card--task-panel"
        enterDelay={0.22}
        inView
        drift={{ x: 4, y: -10, duration: 5.4, durationX: 6.8 }}
      >
        <header className="home-task-panel-head">
          <span className="home-task-panel-icon">
            <FiCheckSquare />
          </span>
          <div>
            <strong>Tasks</strong>
            <p>Task Overview</p>
          </div>
          <FiMoreVertical />
        </header>

        <div className="home-task-stats">
          {STATS.map((stat) => (
            <div key={stat.label} className={stat.tone ? `is-${stat.tone}` : undefined}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>

        <div className="home-task-progress">
          <div className="home-task-progress-label">
            <span>Overall Progress</span>
            <strong>64%</strong>
          </div>
          <div className="home-task-progress-track">
            <motion.i
              initial={reduce ? false : { width: 0 }}
              whileInView={{ width: '64%' }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 1.05, delay: 0.35, ease: HOME_EASE }}
            />
          </div>
        </div>

        <div className="home-task-recent">
          <div className="home-task-recent-head">
            <span>Recent Tasks</span>
            <span>View All</span>
          </div>
          <ul>
            {RECENT_TASKS.map((task, index) => (
              <motion.li
                key={task.title}
                initial={reduce ? false : { opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.42 + index * 0.1, ease: HOME_EASE }}
              >
                <span className="home-task-check" />
                <div>
                  <strong>{task.title}</strong>
                  <small>{task.date}</small>
                </div>
                <em className={`home-task-tag home-task-tag--${task.tone}`}>{task.tag}</em>
              </motion.li>
            ))}
          </ul>
        </div>

        <div className="home-task-foot">
          <span className="home-task-foot-icon">
            <FiUsers />
          </span>
          Team productivity is up 22% compared to last month.
        </div>
      </HomeFloat>
    </div>
  );
};

export default HomeTaskVisual;
